module.exports = __webpack_public_path__ + "static/media/about_4.47f0051d.svg";